<template>
	<div class="document p-2">
		<div class="compass-doc-section p-1">
			<div class="grid">
				<div class="col-6 document-title">
					<p>Building Warrant of Fitness</p>
					<p>Form 12 Section 108</p>
					<p>Building Act 2004 </p>
				</div>
				<div class="col-6 d-block">
					<div class="flex align-items-center justify-content-end gap-3" style="height:60px">
						<div v-if="propertyData.displayCompassLogo" class="css-image compass-logo flex-1" :style="{ height: customerLogoDataUri ? '50px' : '56px', backgroundPosition: customerLogoDataUri ? 'center' : 'right' }"></div>
						<img v-if="customerLogoDataUri" :src="customerLogoDataUri" style="height:38px; max-width:250px;" />
					</div>
				</div>
			</div>
		</div>
		<div class="grid mt-1 pl-4" >
			<div class="col-4 flex p-0">
				<p class="compass-red">Expires:</p>&nbsp;<span v-if="parentBwofService">{{formattedDate(parentBwofService.whenNextServiceAnniversary)}}</span>
			</div>
			<div class="col-4 flex p-0">
				<p class="compass-red">Project No:</p>&nbsp;<span>{{propertyData.propertyId}}</span>
			</div>
			<div class="col-4 flex p-0">
				<p class="compass-red">C.S. No:</p>&nbsp;<span>{{bwof.complianceSchedule}}</span>
			</div>
		</div>
		<div class="compass-doc-section">
			<div class="header">
				<span>BUILDING DETAILS</span>
			</div>
			<div class="body">
				<b>Building name:</b><span>&nbsp;{{propertyData.buildingName}}</span><br />
				<b>Street address of building:</b><span>&nbsp;{{propertyData.streetAddress}} {{propertyData.suburb}} {{propertyData.city}}</span><br />
				<b>Legal description of land where building is located:</b><span>&nbsp;{{bwof.legalDescription}}</span><br />
				<b>Location of building within site:</b><span>&nbsp;{{bwof.locationOfBuildingWithinSite}}</span><br />
				<b>Level / Unit no:</b><span>&nbsp;{{bwof.levelUnitNo}}</span><br />
				<b>Current, lawfully established use:</b><span>&nbsp;{{bwof.buildingUse}}</span><br />
				<b>Year first constructed:</b><span>&nbsp;{{bwof.firstConstructed}}</span><br />
				<b>Intended life of the building if 50 years or less:</b><span>&nbsp;{{bwof.intendedLifeOfTheBuilding}}</span><br />
				<b>Purpose group:</b><span>&nbsp;{{bwof.purposeGroup}}</span><br />
				<b>Highest fire hazard category for building use:</b><span>&nbsp;{{bwof.highestFireHazardCategoryFhcNumber}}</span><br />
				<b>Maximum No. of occupants:</b><span>&nbsp;{{bwof.maximumNumberOfOccupants}}</span><br />
			</div>
		</div>
		<div class="compass-doc-section">
			<div class="header">
				<span>OWNER DETAILS</span>
			</div>
			<div class="body">
				<b>Name:</b><span>&nbsp;{{owner.companyName}}</span><br />
				<b>Mailing address:</b>
				<span>
					&nbsp;{{owner.streetAddress}}
					&nbsp;{{owner.postalAddress}}
					&nbsp;{{owner.suburb}}
					&nbsp;{{owner.city}}
				</span><br />

				<b>Contact name:</b><span>&nbsp;{{contact.firstName}}&nbsp;{{contact.lastName}}</span><br />
				<b>Contact phone:</b><span>&nbsp;{{contact.ddi}}</span><br />
				<b>Contact mobile:</b><span>&nbsp;{{contact.mobile}}</span><br />
				<b>Contact email:</b><span>&nbsp;{{contact.email}}</span><br />
			</div>
		</div>
		<div class="compass-doc-section">
			<div class="header">
				<span>AGENT DETAILS</span>
			</div>
			<div class="body">
				<template v-if="agent">
					<div class="grid">
						<div class="col-6 pt-2">
							<!--<template v-if="bwof.issuedBy == 'Keith'">-->
							<b>Name of agent:</b><span>&nbsp;Compass New Zealand Limited</span><br />
							<b>Contact person:</b><span v-if="bwof.issuedBy == 'John'">&nbsp;John Bell</span><span v-else>&nbsp;Keith Flatt</span><br />
							<b>Phone:</b><span>&nbsp;09 477 2720</span><br />
							<b>Relationship to owner:</b><span>&nbsp;Owner authorised agent </span><br />
							<!--</template>-->
						</div>
						<div class="col6 pt-2">
							<b>Mailing address:</b><span>&nbsp;PO Box 303 484 North Harbour 0751</span><br />
							<b>Email:</b><span>&nbsp;bwof@compassnzl.co.nz</span><br />
						</div>
					</div>
				</template>
			</div>
		</div>
		<div class="compass-doc-section">
			<div class="header">
				<span>SPECIFIED SYSTEMS</span>
			</div>
			<div class="body" v-if="propertyData.services">
				<template v-for="service in bwofServices" :key="service.serviceId">
					<p class="mb-0">{{service.serviceName}}</p>
				</template>

			</div>
		</div>
		<div class="compass-doc-section p-2 mt-1">
			<p class="mb-0">The compliance schedule No. {{bwof.complianceSchedule}} and the written reports obtained in accordance with the compliance schedule are to be kept at: the premises.</p>
			<p class="mb-0">The inspection, maintenance and reporting procedures of the Compliance Schedule for the above building have been fully complied with during the <span v-if="bwof.complianceScheduleMonths == 1">{{bwof.complianceScheduleMonths}} month</span><span v-else>{{bwof.complianceScheduleMonths}} months</span> prior to the date stated below.</p>
		</div>
		<div class="compass-doc-section p-2 mt-1">
			<div class="grid">
				<div class="col-7 flex flex-nowrap">
					Signature of agent on behalf of and with the authority of the owner:
				</div>
				<div class="document-text-border col mr-4 mt-1 css-image" v-bind:class="[bwof.issuedBy == 'John' ? 'signature-john':'signature-keith' ]" >
				</div>
			</div>
			<div class="grid">
				<div class="col-1 flex flex-nowrap">
					Name:&nbsp;
				</div>
				<div class="document-text-border col mr-3 pl-2">
					<span v-if="bwof.issuedBy == 'John'">John Bell</span>
					<span v-else>Keith Flatt</span>
				</div>
			</div>
			<div class="grid">
				<div class="col-1 flex flex-nowrap">
					Position:&nbsp;
				</div>
				<div class="document-text-border col mr-3 pl-2">
					<span v-if="bwof.issuedBy == 'John'">General Manager (Compass New Zealand Ltd)</span>
					<span v-else>Managing Director (Compass New Zealand Ltd)</span>
				</div>
			</div>
			<div class="grid">
				<div class="col-1 flex flex-nowrap">
					Date:&nbsp;
				</div>
				<div class="document-text-border col mr-3 pl-2">
					{{formattedDate(bwof.bwofIssuedDate ?? new Date())}}
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { Vue, Options } from 'vue-class-component';
	import { PropertyData, PropertyServiceData, CompanyData, ContactData, PropertyBwofData } from '@/api-client/api-client'
	import { format, isValid } from 'date-fns';

	@Options({
		name: 'BwofTemplate',
		props: {
			propertyData: null
		}
	})
	export default class BwofTemplate extends Vue {

		// Data
		propertyData: PropertyData = new PropertyData();

		parentBwofService: PropertyServiceData = new PropertyServiceData();

		bwofServices: PropertyServiceData[] = [];

		bwof: PropertyBwofData = new PropertyBwofData();

		owner: CompanyData = new CompanyData();

		contact: ContactData = new ContactData();

		agent: ContactData = new ContactData();

		created() {
			// The Bwof service -- assuming that a property will only have 1 Bwof service
			this.parentBwofService = this.propertyData.services != null ? this.propertyData.services.filter(service => service.serviceId == 1 && service.active == true && service.whenDeleted == null)[0] : this.parentBwofService;

			// Bwof child services
			this.bwofServices = this.propertyData.services != null ? this.propertyData.services.filter(service => service.parentServiceId == 1 && service.active == true && service.whenDeleted == null) : [];

			// Send count of services to parent template for document generation scaling
			this.$emit('updateServicesCount', this.bwofServices.length);

			// Bwof card data
			this.bwof = this.propertyData.propertyBwof != null ? this.propertyData.propertyBwof : this.bwof;
			this.owner = this.propertyData.owner != null ? this.propertyData.owner : this.owner;
			this.contact = this.bwof.ownerContact != null ? this.bwof.ownerContact : this.contact;
			//this.agent = this.bwof.issuedBy;
		}

		formattedDate(date: Date) {
			if (!isValid(date)) return;

			return format(date, 'd MMMM yyyy');
		}

		get customerLogoDataUri(): string | null {
			const base64Svg = this.propertyData.customerBwofTemplateLogo;
			return base64Svg ? `data:image/svg+xml;base64,${base64Svg}` : null;
		}
	}
</script>

<style>

</style>